"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$replaceWith = void 0;
var replaceRoot_1 = require("./replaceRoot");
/**
 * Alias for $replaceRoot
 */
exports.$replaceWith = replaceRoot_1.$replaceRoot;
